import React from 'react';
import PropTypes from 'prop-types';
import FormField from './FormField';
import classnames from 'classnames';
import ErrorsHigherOrderComponent from '../ErrorsHigherOrderComponent';

export default class FormFieldWithLabel extends ErrorsHigherOrderComponent{
  render () {
    const { isCard, className, labelClassName, errors, label, children } = this.props;
    const childrenClassName = classnames({
      'card soft-card': isCard,
      'can-has-errors': 'errors' in this.props,
      'has-errors': (Array.isArray(errors) && errors.filter(error => error).length) || (typeof errors === 'string' && errors.length),
    });
    const formFieldClassName = isCard ? `${className}` : className;
    return (
      <FormField className={formFieldClassName}>
        {
          label
          ? <label className={labelClassName}>{label}</label>
          : null
        }
        <div className={childrenClassName}>
          {children}
          {
            errors
            ? this.getErrorsBlock(errors)
            : null
          }
        </div>
      </FormField>
    );
  }
}

FormFieldWithLabel.propTypes = {
  label: PropTypes.any,
};

FormFieldWithLabel.defaultProps = {
  className: '',
  isCard: false,
};



// WEBPACK FOOTER //
// ./src/common/views/form/FormFieldWithLabel.js